import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AttentionToDirective } from "./attention-to.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [AttentionToDirective],
  exports: [AttentionToDirective]
})
export class AttentionToModule {}
